import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"; // Icons from Ant Design
import SubCategoryCreationForm from "../../Forms/SubCategoryCreationForm/SubCategoryCreationForm"
const SubCategoryTable = ({
  history,
  loading,
  data,
  callReFetch,
  categoryData,
  userData,
  dispatch,
  handleDelete,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Update isMobileView based on window subcategory
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenEditModal = async (id) => {
    const subcategoryToEdit = data.find((subcategory) => subcategory._id === id);
    if (subcategoryToEdit) {
      setSelectedSubCategory(subcategoryToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedSubCategory(null);
  };

  const isAdmin = userData?.roles?.includes("admin");
  const renderActionButton = (id) => {
    if (!isAdmin) return null;
    return (
      <>
        {isMobileView ? (
          // Use icons on mobile view
          <>
            <Tooltip title="Edit">
              <Button
                icon={<EditOutlined />}
                onClick={() => handleOpenEditModal(id)}
                subcategory="small"
                shape="circle"
                style={{ marginRight: 8 }}
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(id)}
                subcategory="small"
                shape="circle"
                danger
              />
            </Tooltip>
          </>
        ) : (
          // Use buttons on desktop view
          <>
            <Button
              onClick={() => handleOpenEditModal(id)}
              style={{ marginRight: 8 }}
            >
              Edit
            </Button>
            <Button onClick={() => handleDelete(id)} danger>
              Delete
            </Button>
          </>
        )}
      </>
    );
  };
  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: true,
    },
    {
      title: "Action",
      render: (item) => renderActionButton(item._id),
      width: 400,
    },
  ];

  return (
    <>
      <div style={{ width: "50vw" }}>
        <Spin spinning={loading}>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              onChange={(pagination, filteredInfo, sorter) =>
                handleTableOnChange(pagination, filteredInfo, sorter)
              }
            />
          )}
        </Spin>
        <Modal
          title="Edit SubCategory"
          open={isEditModalVisible}
          footer={null}
          onCancel={handleCloseEditModal}
        >
          <SubCategoryCreationForm
            history={history}
            isEditMode
            callReFetch={callReFetch}
            categoryData={categoryData}
            data={selectedSubCategory}
            onClose={handleCloseEditModal}
          />
        </Modal>
      </div>
    </>
  );
};

SubCategoryTable.propTypes = {
};

export default SubCategoryTable;
